module.exports = __webpack_public_path__ + "static/media/manichino.7d9b79ac.jpg";